import React from "react";
import {View, StyleSheet} from "react-native";
import PtText from "../../core/pt-text/pt-text";
import PtOrderStatusIndicator from "./../pt-order-status-indicator/pt-order-status-indicator";
import {styleVars} from "../../../app-style-vars";
import {getTranslation} from "../../../helpers/getTranslation";
import PtProductPriceDetails from "./../pt-product-price-details/pt-product-price-details";
import PtOrderItemDetails from "./../pt-order-item-details/pt-order-item-details";
import {PtOrderHistoryBomItemProps} from './pt-order-history-bom-item-props';

export default function PtOrderHistoryBomItem(props: PtOrderHistoryBomItemProps) {

  /** labels */
  const materialNumberLabel = props.materialNumberLabel || getTranslation('order.history.product.material.number.label') || 'Mat. Number';
  const quantityLabel = props.quantityLabel || getTranslation('order.history.product.quantity.label') || 'Quantity';
  const distributionCenterLabel = props.distributionCenterLabel || getTranslation('order.history.product.distribution.center.label') || 'Distribution center';

  /** data */
  const itemData = props.itemData;
  const order = props.order;
  const orderItem = props.orderItem;

  /** renders */
  const renderStatus = () => {
    return (
      <View style={[styles.sectionContainer]}>
        {itemData.statusCode ?
          <View style={[styles.sectionValue]}>
            <PtOrderStatusIndicator statusCode={itemData.statusCode} />
          </View>
          : null
        }
      </View>
    )
  }

  const renderMaterialNumber = () => {
    return (
      <View style={[styles.sectionContainer]}>
        <View style={[styles.sectionLabel]}>
          <PtText style={[styles.sectionLabelText]}>
            {materialNumberLabel}
          </PtText>
        </View>
        <View style={[styles.sectionValue]}>
          <PtText style={[styles.sectionValueText]}>
            {itemData.productId}
          </PtText>
          <PtText style={[styles.sectionValueText]}>
            {itemData.materialDescription}
          </PtText>
        </View>
      </View>
    )
  }

  const renderQuantity = () => {
    return (
      <View style={[styles.sectionContainer]}>
        <View style={[styles.sectionLabel]}>
          <PtText style={[styles.sectionLabelText]}>
            {quantityLabel}
          </PtText>
        </View>
        <View style={[styles.sectionValue]}>
          <PtText style={[styles.sectionValueText]}>
            {itemData.acceptedQuantity}
          </PtText>
        </View>
      </View>
    )
  }

  const renderPriceDetailsSection = () => {
    return (
      <View style={[styles.sectionContainer]}>
        <View style={[styles.sectionLabel]}>
          <PtProductPriceDetails productData={itemData} useModal={true}/>
        </View>
        <View style={[styles.sectionValue]}>
          <PtText style={[styles.sectionValueText, styles.bold]}>
            {itemData?.totalERPPricing?.value?.formattedValue}
          </PtText>
          <PtText style={[styles.sectionValueText]}>
            {itemData?.totalERPPricing?.unitValue?.formattedValue ? `${itemData.totalERPPricing.unitValue.formattedValue}/each` : ''}
          </PtText>
        </View>
      </View>
    )
  }

  const renderDistributionCenter = () => {
    return (
      <View style={[styles.sectionContainer]}>
        <View style={[styles.sectionLabel]}>
          <PtText style={[styles.sectionLabelText]}>
            {distributionCenterLabel}
          </PtText>
        </View>
        <View style={[styles.sectionValue]}>
          <PtText styles={[styles.sectionValueText]}>
            {itemData?.distributionCenter}
          </PtText>
        </View>
      </View>
    )
  }

  return (
    <View style={[styles.bomItemContainer]}>
      {renderStatus()}
      {renderMaterialNumber()}
      {renderQuantity()}
      {renderPriceDetailsSection()}
      {renderDistributionCenter()}

      <View style={[styles.sectionContainer]}>
        <View style={[styles.sectionRow]}>
          <PtOrderItemDetails order={order} orderItem={orderItem}/>
        </View>
      </View>

    </View>
  )
}

const styles = StyleSheet.create({
  bomItemContainer: {
    borderTopWidth: 1,
    borderTopColor: styleVars.boschLightGray,
    paddingVertical: styleVars.rem(.5),
  },
  sectionContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingVertical: styleVars.rem(.125),
  },
  sectionRow: {
    width: '100%'
  },
  sectionLabel: {
    maxWidth: '45%',
  },
  sectionLabelText: {
    fontSize: styleVars.rem(.875),
    fontWeight: '600',
  },
  sectionValue: {
    maxWidth: '50%',
  },
  sectionValueText: {
    fontSize: styleVars.rem(.875),
    textAlign: 'right',
  },
  bold: {
    fontWeight: '600',
  }
})